// eslint-disable-next-line security/detect-unsafe-regex -- safe: anchored, numeric only
const PATTERN_FLOAT_NUMBER = /^\d*([.,]?)(\d+)?$/
const PATTERN_INTEGER_NUMBER = /^\d+$/
// Pattern has nested quantifiers; pair with EMAIL_MAX_LENGTH guard in validateEmail
// to bound backtracking. Don't use this regex on unbounded input.
/* eslint-disable security/detect-unsafe-regex */
export const PATTERN_EMAIL = new RegExp(
  /^([0-9a-zA-Z]+[-._+])*[0-9a-zA-Z]+@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])(?!con$)[a-zA-Z]{2,6}$/
)
/* eslint-enable security/detect-unsafe-regex */

// RFC 5321 caps email addresses at 254 characters; reject longer input before
// running PATTERN_EMAIL to bound regex backtracking.
const EMAIL_MAX_LENGTH = 254

const PATTERN_PASSWORD_LENGTH = /.{10,}/
const PATTERN_UPPER_CASE = /[A-ZČĐŠŽ]/
const PATTERN_DIGIT = /\d/
const PATTERN_SPECIAL_CHARACTER = /[^\w\s]|_/
// eslint-disable-next-line security/detect-unsafe-regex -- false positive: anchored, fixed-length
const PATTERN_ZIP_CODE = /^[0-9]{5}(?:-[0-9]{4})?$/

const MILITARY_ZIP_CODES_PREFIXES = [
  // APO AE - Europe, Middle East, etc
  '090',
  '091',
  '092',
  '093',
  '094',
  '095',
  '096',
  '097',
  '098',
  '099',
  // APO AA - Americas
  '340',
  // APO AP – Pacific
  '962',
  '963',
  '964',
  '965',
  '966'
]

export const validateFloatNumberInput = (value: string) => {
  if (value.length === 0) {
    return value
  }

  const parsedValue = Number.parseFloat(value)

  const processedValue = value.replace(',', '.')

  if (processedValue === '.') {
    return '0.'
  }

  if (!value.match(PATTERN_FLOAT_NUMBER) || isNaN(parsedValue)) {
    return null
  }

  if (processedValue.length >= 2 && processedValue[0] === '0' && processedValue[1] !== '.') {
    return processedValue.substring(1)
  }

  return processedValue
}

export const validateIntegerNumberInput = (value: string) => {
  if (value.length === 0) {
    return value
  }

  const parsedValue = Number(value)

  if (!value.match(PATTERN_INTEGER_NUMBER) || isNaN(parsedValue)) {
    return null
  }

  const processedValue = value

  if (processedValue.length >= 2 && processedValue[0] === '0') {
    return processedValue.substring(1)
  }

  return value
}

export const validateEmail = (value: string) => {
  if (!value || value.length > EMAIL_MAX_LENGTH) {
    return false
  }

  return PATTERN_EMAIL.test(value)
}

const RegExpValidator = (regexp: RegExp, value: string) => {
  if (!value) {
    return false
  }

  return regexp.test(value)
}

export const PasswordLengthValidator = (value: string) => {
  return RegExpValidator(PATTERN_PASSWORD_LENGTH, value)
}

export const UpperCaseValidator = (value: string) => {
  return RegExpValidator(PATTERN_UPPER_CASE, value)
}

export const DigitValidator = (value: string) => {
  return RegExpValidator(PATTERN_DIGIT, value)
}

export const SpecialCharacterValidator = (value: string) => {
  return RegExpValidator(PATTERN_SPECIAL_CHARACTER, value)
}

export const PasswordValidator = (value: string) => {
  return (
    PasswordLengthValidator(value) &&
    UpperCaseValidator(value) &&
    (DigitValidator(value) || SpecialCharacterValidator(value))
  )
}

export const validateZipCode = (value: string | null) => {
  if (!value) {
    return false
  }

  const prefix = value.substring(0, 3)
  return PATTERN_ZIP_CODE.test(value) && !MILITARY_ZIP_CODES_PREFIXES.includes(prefix)
}
